import { Camera, Loader2, Upload } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { Label } from "../ui/label";
import { Button } from "../ui/button";
import { useAuth } from "../../contexts/AuthContext";
import { useRef, useState } from "react";

export const ProfileImage = () => {
  const { updateProfileImage, getUserAvatar } = useAuth();
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);

    if (file) {
      const reader = new FileReader();
      reader.onload = () => setPreviewImage(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedFile) return;

    setLoading(true);
    setSuccessMessage("");

    const result = await updateProfileImage(selectedFile);

    setLoading(false);

    if (result.success) {
      console.log("Image updated successfully!");
      setSuccessMessage("Profile image updated successfully!");
      setSelectedFile(null);
      setPreviewImage(null);

      // Clear message after 3 seconds
      setTimeout(() => {
        setSuccessMessage("");
      }, 3000);
    } else {
      console.error("Image update failed:", result.error);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col items-center space-y-4 pb-6 border-b">
        <div className="relative">
          <Avatar className="w-24 h-24">
            <AvatarImage src={previewImage || getUserAvatar()} />
            <AvatarFallback></AvatarFallback>
          </Avatar>
          <Label
            htmlFor="image"
            className="absolute -bottom-2 -right-2 bg-igbanwo-mint text-white rounded-full p-2 cursor-pointer transition-colors shadow-lg"
          >
            <Camera className="w-4 h-4" />
          </Label>
          <input
            id="image"
            ref={fileInputRef}
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleFileChange}
          />
        </div>
        <p className="text-sm text-muted-foreground text-center">
          Click the camera icon to upload a new profile photo
        </p>

        {successMessage && (
          <div className="text-green-600 text-sm font-medium">{successMessage}</div>
        )}

        <div>
          <Button type="submit" disabled={!selectedFile || loading}>
            {loading ? (
              <>
                <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                Updating...
              </>
            ) : (
              <>
                <Upload className="mr-2 w-4 h-4" />
                Update Image
              </>
            )}
          </Button>
        </div>
      </div>
    </form>
  );
};
